import LoginPage from "../views/pages/login/LoginPage";

const authenticationRoutes = {
  path: "/login",
  element: <LoginPage />,
};

export default authenticationRoutes;
